var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1355 15.1414C15.6761 14.6008 16.105 13.959 16.3975 13.2527C16.6901 12.5464 16.8407 11.7893 16.8407 11.0248C16.8407 10.2603 16.6901 9.50328 16.3975 8.79696C16.105 8.09064 15.6761 7.44886 15.1355 6.90826C14.5949 6.36767 13.9532 5.93884 13.2468 5.64628C12.5405 5.35371 11.7835 5.20312 11.019 5.20312C10.2545 5.20313 9.49742 5.35371 8.7911 5.64628C8.08478 5.93884 7.443 6.36767 6.9024 6.90826C5.81062 8.00004 5.19727 9.48082 5.19727 11.0248C5.19727 12.5688 5.81062 14.0496 6.9024 15.1414C7.99419 16.2332 9.47496 16.8465 11.019 16.8465C12.563 16.8465 14.0438 16.2332 15.1355 15.1414ZM15.1355 15.1414L18.8023 18.8082",
    stroke: "#2A2A2A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.14f61944e4ba00ed635c5cf43e3eb8eb.svg";
export { ForwardRef as ReactComponent };